import styled from 'styled-components';
import { clearFixMixin } from '../../mixins/clearFixMixin';
/**
 * While traditionally a clearfix was used as a way to
 * [clear layout issues with floated elements](https://css-tricks.com/clearfix-a-lesson-in-web-development-evolution/),
 * this can also be used to manage
 * [margin collapse](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing).
 *
 * @since 8.15.0
 */

var ClearFix = /*#__PURE__*/styled.div.withConfig({
  displayName: "ClearFix",
  componentId: "c11n-8-64-0__sc-1tt6y0b-0"
})(["", ""], clearFixMixin);
/** @component */

export default ClearFix;
export var StyledClearFix = ClearFix;